"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsgClientImpl = exports.MsgRemoveHistoricalBucketInfoResponse = exports.MsgRemoveHistoricalBucketInfo = exports.MsgCreateHistoricalBucketInfoResponse = exports.MsgCreateHistoricalBucketInfo = exports.MsgCreateResultResponse = exports.MsgCreateResult = exports.VotesForTimestamp = exports.VotesForData = exports.VotesForOracle = exports.ValidatorSignature = exports.MsgDeployOracleContractResponse = exports.MsgDeployOracleContract = exports.MsgUpdateOracleContractResponse = exports.MsgUpdateOracleContract = exports.MsgUpdateParamsResponse = exports.MsgUpdateParams = exports.MsgSetOracleSlashEnabledResponse = exports.MsgSetOracleSlashEnabled = exports.MsgRemoveOracleResponse = exports.MsgRemoveOracle = exports.MsgUpdateOracleResponse = exports.UpdateOracleParams = exports.MsgUpdateOracle = exports.MsgCreateOracleResponse = exports.CreateOracleParams = exports.MsgCreateOracle = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const params_1 = require("./params");
const duration_1 = require("../../../google/protobuf/duration");
const wrappers_1 = require("../../../google/protobuf/wrappers");
exports.protobufPackage = "Switcheo.carbon.oracle";
const baseMsgCreateOracle = { creator: "" };
exports.MsgCreateOracle = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.createOracleParams !== undefined) {
            exports.CreateOracleParams.encode(message.createOracleParams, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateOracle);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.createOracleParams = exports.CreateOracleParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgCreateOracle);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.createOracleParams =
            object.createOracleParams !== undefined &&
                object.createOracleParams !== null
                ? exports.CreateOracleParams.fromJSON(object.createOracleParams)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.createOracleParams !== undefined &&
            (obj.createOracleParams = message.createOracleParams
                ? exports.CreateOracleParams.toJSON(message.createOracleParams)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgCreateOracle);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.createOracleParams =
            object.createOracleParams !== undefined &&
                object.createOracleParams !== null
                ? exports.CreateOracleParams.fromPartial(object.createOracleParams)
                : undefined;
        return message;
    },
};
const baseCreateOracleParams = {
    creator: "",
    id: "",
    description: "",
    minTurnoutPercentage: long_1.default.ZERO,
    maxResultAge: long_1.default.ZERO,
    securityType: "",
    resultStrategy: "",
    resolution: long_1.default.ZERO,
    spec: "",
    enableHistoricalResults: false,
};
exports.CreateOracleParams = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.id !== "") {
            writer.uint32(18).string(message.id);
        }
        if (message.description !== "") {
            writer.uint32(26).string(message.description);
        }
        if (!message.minTurnoutPercentage.isZero()) {
            writer.uint32(32).int64(message.minTurnoutPercentage);
        }
        if (!message.maxResultAge.isZero()) {
            writer.uint32(40).int64(message.maxResultAge);
        }
        if (message.securityType !== "") {
            writer.uint32(50).string(message.securityType);
        }
        if (message.resultStrategy !== "") {
            writer.uint32(58).string(message.resultStrategy);
        }
        if (!message.resolution.isZero()) {
            writer.uint32(64).int64(message.resolution);
        }
        if (message.spec !== "") {
            writer.uint32(74).string(message.spec);
        }
        if (message.enableHistoricalResults === true) {
            writer.uint32(80).bool(message.enableHistoricalResults);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseCreateOracleParams);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.id = reader.string();
                    break;
                case 3:
                    message.description = reader.string();
                    break;
                case 4:
                    message.minTurnoutPercentage = reader.int64();
                    break;
                case 5:
                    message.maxResultAge = reader.int64();
                    break;
                case 6:
                    message.securityType = reader.string();
                    break;
                case 7:
                    message.resultStrategy = reader.string();
                    break;
                case 8:
                    message.resolution = reader.int64();
                    break;
                case 9:
                    message.spec = reader.string();
                    break;
                case 10:
                    message.enableHistoricalResults = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseCreateOracleParams);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.id =
            object.id !== undefined && object.id !== null ? String(object.id) : "";
        message.description =
            object.description !== undefined && object.description !== null
                ? String(object.description)
                : "";
        message.minTurnoutPercentage =
            object.minTurnoutPercentage !== undefined &&
                object.minTurnoutPercentage !== null
                ? long_1.default.fromString(object.minTurnoutPercentage)
                : long_1.default.ZERO;
        message.maxResultAge =
            object.maxResultAge !== undefined && object.maxResultAge !== null
                ? long_1.default.fromString(object.maxResultAge)
                : long_1.default.ZERO;
        message.securityType =
            object.securityType !== undefined && object.securityType !== null
                ? String(object.securityType)
                : "";
        message.resultStrategy =
            object.resultStrategy !== undefined && object.resultStrategy !== null
                ? String(object.resultStrategy)
                : "";
        message.resolution =
            object.resolution !== undefined && object.resolution !== null
                ? long_1.default.fromString(object.resolution)
                : long_1.default.ZERO;
        message.spec =
            object.spec !== undefined && object.spec !== null
                ? String(object.spec)
                : "";
        message.enableHistoricalResults =
            object.enableHistoricalResults !== undefined &&
                object.enableHistoricalResults !== null
                ? Boolean(object.enableHistoricalResults)
                : false;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.id !== undefined && (obj.id = message.id);
        message.description !== undefined &&
            (obj.description = message.description);
        message.minTurnoutPercentage !== undefined &&
            (obj.minTurnoutPercentage = (message.minTurnoutPercentage || long_1.default.ZERO).toString());
        message.maxResultAge !== undefined &&
            (obj.maxResultAge = (message.maxResultAge || long_1.default.ZERO).toString());
        message.securityType !== undefined &&
            (obj.securityType = message.securityType);
        message.resultStrategy !== undefined &&
            (obj.resultStrategy = message.resultStrategy);
        message.resolution !== undefined &&
            (obj.resolution = (message.resolution || long_1.default.ZERO).toString());
        message.spec !== undefined && (obj.spec = message.spec);
        message.enableHistoricalResults !== undefined &&
            (obj.enableHistoricalResults = message.enableHistoricalResults);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g;
        const message = Object.assign({}, baseCreateOracleParams);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.id = (_b = object.id) !== null && _b !== void 0 ? _b : "";
        message.description = (_c = object.description) !== null && _c !== void 0 ? _c : "";
        message.minTurnoutPercentage =
            object.minTurnoutPercentage !== undefined &&
                object.minTurnoutPercentage !== null
                ? long_1.default.fromValue(object.minTurnoutPercentage)
                : long_1.default.ZERO;
        message.maxResultAge =
            object.maxResultAge !== undefined && object.maxResultAge !== null
                ? long_1.default.fromValue(object.maxResultAge)
                : long_1.default.ZERO;
        message.securityType = (_d = object.securityType) !== null && _d !== void 0 ? _d : "";
        message.resultStrategy = (_e = object.resultStrategy) !== null && _e !== void 0 ? _e : "";
        message.resolution =
            object.resolution !== undefined && object.resolution !== null
                ? long_1.default.fromValue(object.resolution)
                : long_1.default.ZERO;
        message.spec = (_f = object.spec) !== null && _f !== void 0 ? _f : "";
        message.enableHistoricalResults = (_g = object.enableHistoricalResults) !== null && _g !== void 0 ? _g : false;
        return message;
    },
};
const baseMsgCreateOracleResponse = { id: "" };
exports.MsgCreateOracleResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateOracleResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgCreateOracleResponse);
        message.id =
            object.id !== undefined && object.id !== null ? String(object.id) : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgCreateOracleResponse);
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseMsgUpdateOracle = { updater: "" };
exports.MsgUpdateOracle = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.updater !== "") {
            writer.uint32(10).string(message.updater);
        }
        if (message.updateOracleParams !== undefined) {
            exports.UpdateOracleParams.encode(message.updateOracleParams, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateOracle);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.updater = reader.string();
                    break;
                case 2:
                    message.updateOracleParams = exports.UpdateOracleParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUpdateOracle);
        message.updater =
            object.updater !== undefined && object.updater !== null
                ? String(object.updater)
                : "";
        message.updateOracleParams =
            object.updateOracleParams !== undefined &&
                object.updateOracleParams !== null
                ? exports.UpdateOracleParams.fromJSON(object.updateOracleParams)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.updater !== undefined && (obj.updater = message.updater);
        message.updateOracleParams !== undefined &&
            (obj.updateOracleParams = message.updateOracleParams
                ? exports.UpdateOracleParams.toJSON(message.updateOracleParams)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgUpdateOracle);
        message.updater = (_a = object.updater) !== null && _a !== void 0 ? _a : "";
        message.updateOracleParams =
            object.updateOracleParams !== undefined &&
                object.updateOracleParams !== null
                ? exports.UpdateOracleParams.fromPartial(object.updateOracleParams)
                : undefined;
        return message;
    },
};
const baseUpdateOracleParams = { id: "" };
exports.UpdateOracleParams = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.description !== undefined) {
            wrappers_1.StringValue.encode({ value: message.description }, writer.uint32(18).fork()).ldelim();
        }
        if (message.status !== undefined) {
            wrappers_1.StringValue.encode({ value: message.status }, writer.uint32(26).fork()).ldelim();
        }
        if (message.minTurnoutPercentage !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.minTurnoutPercentage }, writer.uint32(34).fork()).ldelim();
        }
        if (message.maxResultAge !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.maxResultAge }, writer.uint32(42).fork()).ldelim();
        }
        if (message.securityType !== undefined) {
            wrappers_1.StringValue.encode({ value: message.securityType }, writer.uint32(50).fork()).ldelim();
        }
        if (message.resultStrategy !== undefined) {
            wrappers_1.StringValue.encode({ value: message.resultStrategy }, writer.uint32(58).fork()).ldelim();
        }
        if (message.resolution !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.resolution }, writer.uint32(66).fork()).ldelim();
        }
        if (message.spec !== undefined) {
            wrappers_1.StringValue.encode({ value: message.spec }, writer.uint32(74).fork()).ldelim();
        }
        if (message.enableHistoricalResults !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.enableHistoricalResults }, writer.uint32(82).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseUpdateOracleParams);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.description = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.status = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 4:
                    message.minTurnoutPercentage = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 5:
                    message.maxResultAge = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 6:
                    message.securityType = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 7:
                    message.resultStrategy = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 8:
                    message.resolution = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 9:
                    message.spec = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 10:
                    message.enableHistoricalResults = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseUpdateOracleParams);
        message.id =
            object.id !== undefined && object.id !== null ? String(object.id) : "";
        message.description =
            object.description !== undefined && object.description !== null
                ? String(object.description)
                : undefined;
        message.status =
            object.status !== undefined && object.status !== null
                ? String(object.status)
                : undefined;
        message.minTurnoutPercentage =
            object.minTurnoutPercentage !== undefined &&
                object.minTurnoutPercentage !== null
                ? long_1.default.fromValue(object.minTurnoutPercentage)
                : undefined;
        message.maxResultAge =
            object.maxResultAge !== undefined && object.maxResultAge !== null
                ? long_1.default.fromValue(object.maxResultAge)
                : undefined;
        message.securityType =
            object.securityType !== undefined && object.securityType !== null
                ? String(object.securityType)
                : undefined;
        message.resultStrategy =
            object.resultStrategy !== undefined && object.resultStrategy !== null
                ? String(object.resultStrategy)
                : undefined;
        message.resolution =
            object.resolution !== undefined && object.resolution !== null
                ? long_1.default.fromValue(object.resolution)
                : undefined;
        message.spec =
            object.spec !== undefined && object.spec !== null
                ? String(object.spec)
                : undefined;
        message.enableHistoricalResults =
            object.enableHistoricalResults !== undefined &&
                object.enableHistoricalResults !== null
                ? Boolean(object.enableHistoricalResults)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        message.description !== undefined &&
            (obj.description = message.description);
        message.status !== undefined && (obj.status = message.status);
        message.minTurnoutPercentage !== undefined &&
            (obj.minTurnoutPercentage = message.minTurnoutPercentage);
        message.maxResultAge !== undefined &&
            (obj.maxResultAge = message.maxResultAge);
        message.securityType !== undefined &&
            (obj.securityType = message.securityType);
        message.resultStrategy !== undefined &&
            (obj.resultStrategy = message.resultStrategy);
        message.resolution !== undefined && (obj.resolution = message.resolution);
        message.spec !== undefined && (obj.spec = message.spec);
        message.enableHistoricalResults !== undefined &&
            (obj.enableHistoricalResults = message.enableHistoricalResults);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g;
        const message = Object.assign({}, baseUpdateOracleParams);
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        message.description = (_b = object.description) !== null && _b !== void 0 ? _b : undefined;
        message.status = (_c = object.status) !== null && _c !== void 0 ? _c : undefined;
        message.minTurnoutPercentage =
            object.minTurnoutPercentage !== undefined &&
                object.minTurnoutPercentage !== null
                ? long_1.default.fromValue(object.minTurnoutPercentage)
                : undefined;
        message.maxResultAge =
            object.maxResultAge !== undefined && object.maxResultAge !== null
                ? long_1.default.fromValue(object.maxResultAge)
                : undefined;
        message.securityType = (_d = object.securityType) !== null && _d !== void 0 ? _d : undefined;
        message.resultStrategy = (_e = object.resultStrategy) !== null && _e !== void 0 ? _e : undefined;
        message.resolution =
            object.resolution !== undefined && object.resolution !== null
                ? long_1.default.fromValue(object.resolution)
                : undefined;
        message.spec = (_f = object.spec) !== null && _f !== void 0 ? _f : undefined;
        message.enableHistoricalResults =
            (_g = object.enableHistoricalResults) !== null && _g !== void 0 ? _g : undefined;
        return message;
    },
};
const baseMsgUpdateOracleResponse = {};
exports.MsgUpdateOracleResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateOracleResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgUpdateOracleResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgUpdateOracleResponse);
        return message;
    },
};
const baseMsgRemoveOracle = { creator: "", oracleId: "" };
exports.MsgRemoveOracle = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.oracleId !== "") {
            writer.uint32(18).string(message.oracleId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRemoveOracle);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.oracleId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgRemoveOracle);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.oracleId =
            object.oracleId !== undefined && object.oracleId !== null
                ? String(object.oracleId)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.oracleId !== undefined && (obj.oracleId = message.oracleId);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgRemoveOracle);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.oracleId = (_b = object.oracleId) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMsgRemoveOracleResponse = {};
exports.MsgRemoveOracleResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRemoveOracleResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgRemoveOracleResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgRemoveOracleResponse);
        return message;
    },
};
const baseMsgSetOracleSlashEnabled = { creator: "", enabled: false };
exports.MsgSetOracleSlashEnabled = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.enabled === true) {
            writer.uint32(16).bool(message.enabled);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetOracleSlashEnabled);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.enabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgSetOracleSlashEnabled);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.enabled =
            object.enabled !== undefined && object.enabled !== null
                ? Boolean(object.enabled)
                : false;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.enabled !== undefined && (obj.enabled = message.enabled);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgSetOracleSlashEnabled);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.enabled = (_b = object.enabled) !== null && _b !== void 0 ? _b : false;
        return message;
    },
};
const baseMsgSetOracleSlashEnabledResponse = {};
exports.MsgSetOracleSlashEnabledResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetOracleSlashEnabledResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgSetOracleSlashEnabledResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgSetOracleSlashEnabledResponse);
        return message;
    },
};
const baseMsgUpdateParams = { authority: "" };
exports.MsgUpdateParams = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.authority !== "") {
            writer.uint32(10).string(message.authority);
        }
        if (message.params !== undefined) {
            params_1.ParamsToUpdate.encode(message.params, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateParams);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.params = params_1.ParamsToUpdate.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUpdateParams);
        message.authority =
            object.authority !== undefined && object.authority !== null
                ? String(object.authority)
                : "";
        message.params =
            object.params !== undefined && object.params !== null
                ? params_1.ParamsToUpdate.fromJSON(object.params)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.params !== undefined &&
            (obj.params = message.params
                ? params_1.ParamsToUpdate.toJSON(message.params)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgUpdateParams);
        message.authority = (_a = object.authority) !== null && _a !== void 0 ? _a : "";
        message.params =
            object.params !== undefined && object.params !== null
                ? params_1.ParamsToUpdate.fromPartial(object.params)
                : undefined;
        return message;
    },
};
const baseMsgUpdateParamsResponse = {};
exports.MsgUpdateParamsResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateParamsResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgUpdateParamsResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgUpdateParamsResponse);
        return message;
    },
};
const baseMsgUpdateOracleContract = {
    creator: "",
    oracleId: "",
    contractAddress: "",
};
exports.MsgUpdateOracleContract = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.oracleId !== "") {
            writer.uint32(18).string(message.oracleId);
        }
        if (message.contractAddress !== "") {
            writer.uint32(26).string(message.contractAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateOracleContract);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.oracleId = reader.string();
                    break;
                case 3:
                    message.contractAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUpdateOracleContract);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.oracleId =
            object.oracleId !== undefined && object.oracleId !== null
                ? String(object.oracleId)
                : "";
        message.contractAddress =
            object.contractAddress !== undefined && object.contractAddress !== null
                ? String(object.contractAddress)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.oracleId !== undefined && (obj.oracleId = message.oracleId);
        message.contractAddress !== undefined &&
            (obj.contractAddress = message.contractAddress);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseMsgUpdateOracleContract);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.oracleId = (_b = object.oracleId) !== null && _b !== void 0 ? _b : "";
        message.contractAddress = (_c = object.contractAddress) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
const baseMsgUpdateOracleContractResponse = {};
exports.MsgUpdateOracleContractResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateOracleContractResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgUpdateOracleContractResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgUpdateOracleContractResponse);
        return message;
    },
};
const baseMsgDeployOracleContract = { creator: "", oracleId: "" };
exports.MsgDeployOracleContract = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.oracleId !== "") {
            writer.uint32(18).string(message.oracleId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgDeployOracleContract);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.oracleId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgDeployOracleContract);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.oracleId =
            object.oracleId !== undefined && object.oracleId !== null
                ? String(object.oracleId)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.oracleId !== undefined && (obj.oracleId = message.oracleId);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgDeployOracleContract);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.oracleId = (_b = object.oracleId) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMsgDeployOracleContractResponse = {};
exports.MsgDeployOracleContractResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgDeployOracleContractResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgDeployOracleContractResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgDeployOracleContractResponse);
        return message;
    },
};
const baseValidatorSignature = {
    validatorIndex: 0,
    signedTimestamp: long_1.default.ZERO,
};
exports.ValidatorSignature = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pubKey.length !== 0) {
            writer.uint32(10).bytes(message.pubKey);
        }
        if (message.validatorIndex !== 0) {
            writer.uint32(16).int32(message.validatorIndex);
        }
        if (message.signature.length !== 0) {
            writer.uint32(26).bytes(message.signature);
        }
        if (!message.signedTimestamp.isZero()) {
            writer.uint32(32).int64(message.signedTimestamp);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseValidatorSignature);
        message.pubKey = new Uint8Array();
        message.signature = new Uint8Array();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pubKey = reader.bytes();
                    break;
                case 2:
                    message.validatorIndex = reader.int32();
                    break;
                case 3:
                    message.signature = reader.bytes();
                    break;
                case 4:
                    message.signedTimestamp = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseValidatorSignature);
        message.pubKey =
            object.pubKey !== undefined && object.pubKey !== null
                ? bytesFromBase64(object.pubKey)
                : new Uint8Array();
        message.validatorIndex =
            object.validatorIndex !== undefined && object.validatorIndex !== null
                ? Number(object.validatorIndex)
                : 0;
        message.signature =
            object.signature !== undefined && object.signature !== null
                ? bytesFromBase64(object.signature)
                : new Uint8Array();
        message.signedTimestamp =
            object.signedTimestamp !== undefined && object.signedTimestamp !== null
                ? long_1.default.fromString(object.signedTimestamp)
                : long_1.default.ZERO;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pubKey !== undefined &&
            (obj.pubKey = base64FromBytes(message.pubKey !== undefined ? message.pubKey : new Uint8Array()));
        message.validatorIndex !== undefined &&
            (obj.validatorIndex = message.validatorIndex);
        message.signature !== undefined &&
            (obj.signature = base64FromBytes(message.signature !== undefined ? message.signature : new Uint8Array()));
        message.signedTimestamp !== undefined &&
            (obj.signedTimestamp = (message.signedTimestamp || long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseValidatorSignature);
        message.pubKey = (_a = object.pubKey) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.validatorIndex = (_b = object.validatorIndex) !== null && _b !== void 0 ? _b : 0;
        message.signature = (_c = object.signature) !== null && _c !== void 0 ? _c : new Uint8Array();
        message.signedTimestamp =
            object.signedTimestamp !== undefined && object.signedTimestamp !== null
                ? long_1.default.fromValue(object.signedTimestamp)
                : long_1.default.ZERO;
        return message;
    },
};
const baseVotesForOracle = { oracleIndex: 0 };
exports.VotesForOracle = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.oracleIndex !== 0) {
            writer.uint32(8).int32(message.oracleIndex);
        }
        for (const v of message.votesForData) {
            exports.VotesForData.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseVotesForOracle);
        message.votesForData = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.oracleIndex = reader.int32();
                    break;
                case 2:
                    message.votesForData.push(exports.VotesForData.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseVotesForOracle);
        message.oracleIndex =
            object.oracleIndex !== undefined && object.oracleIndex !== null
                ? Number(object.oracleIndex)
                : 0;
        message.votesForData = ((_a = object.votesForData) !== null && _a !== void 0 ? _a : []).map((e) => exports.VotesForData.fromJSON(e));
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.oracleIndex !== undefined &&
            (obj.oracleIndex = message.oracleIndex);
        if (message.votesForData) {
            obj.votesForData = message.votesForData.map((e) => e ? exports.VotesForData.toJSON(e) : undefined);
        }
        else {
            obj.votesForData = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseVotesForOracle);
        message.oracleIndex = (_a = object.oracleIndex) !== null && _a !== void 0 ? _a : 0;
        message.votesForData = ((_b = object.votesForData) !== null && _b !== void 0 ? _b : []).map((e) => exports.VotesForData.fromPartial(e));
        return message;
    },
};
const baseVotesForData = { data: "" };
exports.VotesForData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.data !== "") {
            writer.uint32(10).string(message.data);
        }
        for (const v of message.votesForTimestamps) {
            exports.VotesForTimestamp.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseVotesForData);
        message.votesForTimestamps = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.data = reader.string();
                    break;
                case 2:
                    message.votesForTimestamps.push(exports.VotesForTimestamp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseVotesForData);
        message.data =
            object.data !== undefined && object.data !== null
                ? String(object.data)
                : "";
        message.votesForTimestamps = ((_a = object.votesForTimestamps) !== null && _a !== void 0 ? _a : []).map((e) => exports.VotesForTimestamp.fromJSON(e));
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.data !== undefined && (obj.data = message.data);
        if (message.votesForTimestamps) {
            obj.votesForTimestamps = message.votesForTimestamps.map((e) => e ? exports.VotesForTimestamp.toJSON(e) : undefined);
        }
        else {
            obj.votesForTimestamps = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseVotesForData);
        message.data = (_a = object.data) !== null && _a !== void 0 ? _a : "";
        message.votesForTimestamps = ((_b = object.votesForTimestamps) !== null && _b !== void 0 ? _b : []).map((e) => exports.VotesForTimestamp.fromPartial(e));
        return message;
    },
};
const baseVotesForTimestamp = {
    timestamp: long_1.default.ZERO,
    validatorIndexes: 0,
};
exports.VotesForTimestamp = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.timestamp.isZero()) {
            writer.uint32(8).int64(message.timestamp);
        }
        writer.uint32(18).fork();
        for (const v of message.validatorIndexes) {
            writer.int32(v);
        }
        writer.ldelim();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseVotesForTimestamp);
        message.validatorIndexes = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.timestamp = reader.int64();
                    break;
                case 2:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.validatorIndexes.push(reader.int32());
                        }
                    }
                    else {
                        message.validatorIndexes.push(reader.int32());
                    }
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseVotesForTimestamp);
        message.timestamp =
            object.timestamp !== undefined && object.timestamp !== null
                ? long_1.default.fromString(object.timestamp)
                : long_1.default.ZERO;
        message.validatorIndexes = ((_a = object.validatorIndexes) !== null && _a !== void 0 ? _a : []).map((e) => Number(e));
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.timestamp !== undefined &&
            (obj.timestamp = (message.timestamp || long_1.default.ZERO).toString());
        if (message.validatorIndexes) {
            obj.validatorIndexes = message.validatorIndexes.map((e) => e);
        }
        else {
            obj.validatorIndexes = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseVotesForTimestamp);
        message.timestamp =
            object.timestamp !== undefined && object.timestamp !== null
                ? long_1.default.fromValue(object.timestamp)
                : long_1.default.ZERO;
        message.validatorIndexes = ((_a = object.validatorIndexes) !== null && _a !== void 0 ? _a : []).map((e) => e);
        return message;
    },
};
const baseMsgCreateResult = { proposer: "" };
exports.MsgCreateResult = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.proposer !== "") {
            writer.uint32(10).string(message.proposer);
        }
        for (const v of message.validatorSignatures) {
            exports.ValidatorSignature.encode(v, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.votesForOracles) {
            exports.VotesForOracle.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateResult);
        message.validatorSignatures = [];
        message.votesForOracles = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.proposer = reader.string();
                    break;
                case 2:
                    message.validatorSignatures.push(exports.ValidatorSignature.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.votesForOracles.push(exports.VotesForOracle.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgCreateResult);
        message.proposer =
            object.proposer !== undefined && object.proposer !== null
                ? String(object.proposer)
                : "";
        message.validatorSignatures = ((_a = object.validatorSignatures) !== null && _a !== void 0 ? _a : []).map((e) => exports.ValidatorSignature.fromJSON(e));
        message.votesForOracles = ((_b = object.votesForOracles) !== null && _b !== void 0 ? _b : []).map((e) => exports.VotesForOracle.fromJSON(e));
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.proposer !== undefined && (obj.proposer = message.proposer);
        if (message.validatorSignatures) {
            obj.validatorSignatures = message.validatorSignatures.map((e) => e ? exports.ValidatorSignature.toJSON(e) : undefined);
        }
        else {
            obj.validatorSignatures = [];
        }
        if (message.votesForOracles) {
            obj.votesForOracles = message.votesForOracles.map((e) => e ? exports.VotesForOracle.toJSON(e) : undefined);
        }
        else {
            obj.votesForOracles = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseMsgCreateResult);
        message.proposer = (_a = object.proposer) !== null && _a !== void 0 ? _a : "";
        message.validatorSignatures = ((_b = object.validatorSignatures) !== null && _b !== void 0 ? _b : []).map((e) => exports.ValidatorSignature.fromPartial(e));
        message.votesForOracles = ((_c = object.votesForOracles) !== null && _c !== void 0 ? _c : []).map((e) => exports.VotesForOracle.fromPartial(e));
        return message;
    },
};
const baseMsgCreateResultResponse = {};
exports.MsgCreateResultResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateResultResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgCreateResultResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgCreateResultResponse);
        return message;
    },
};
const baseMsgCreateHistoricalBucketInfo = { creator: "" };
exports.MsgCreateHistoricalBucketInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.duration !== undefined) {
            duration_1.Duration.encode(message.duration, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateHistoricalBucketInfo);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.duration = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgCreateHistoricalBucketInfo);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.duration =
            object.duration !== undefined && object.duration !== null
                ? duration_1.Duration.fromJSON(object.duration)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.duration !== undefined &&
            (obj.duration = message.duration
                ? duration_1.Duration.toJSON(message.duration)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgCreateHistoricalBucketInfo);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.duration =
            object.duration !== undefined && object.duration !== null
                ? duration_1.Duration.fromPartial(object.duration)
                : undefined;
        return message;
    },
};
const baseMsgCreateHistoricalBucketInfoResponse = {};
exports.MsgCreateHistoricalBucketInfoResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateHistoricalBucketInfoResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgCreateHistoricalBucketInfoResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgCreateHistoricalBucketInfoResponse);
        return message;
    },
};
const baseMsgRemoveHistoricalBucketInfo = { creator: "" };
exports.MsgRemoveHistoricalBucketInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.duration !== undefined) {
            duration_1.Duration.encode(message.duration, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRemoveHistoricalBucketInfo);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.duration = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgRemoveHistoricalBucketInfo);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.duration =
            object.duration !== undefined && object.duration !== null
                ? duration_1.Duration.fromJSON(object.duration)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.duration !== undefined &&
            (obj.duration = message.duration
                ? duration_1.Duration.toJSON(message.duration)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgRemoveHistoricalBucketInfo);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.duration =
            object.duration !== undefined && object.duration !== null
                ? duration_1.Duration.fromPartial(object.duration)
                : undefined;
        return message;
    },
};
const baseMsgRemoveHistoricalBucketInfoResponse = {};
exports.MsgRemoveHistoricalBucketInfoResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRemoveHistoricalBucketInfoResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgRemoveHistoricalBucketInfoResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgRemoveHistoricalBucketInfoResponse);
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.CreateOracle = this.CreateOracle.bind(this);
        this.UpdateOracle = this.UpdateOracle.bind(this);
        this.RemoveOracle = this.RemoveOracle.bind(this);
        this.SetOracleSlashEnabled = this.SetOracleSlashEnabled.bind(this);
        this.UpdateOracleContract = this.UpdateOracleContract.bind(this);
        this.DeployOracleContract = this.DeployOracleContract.bind(this);
        this.UpdateParams = this.UpdateParams.bind(this);
        this.CreateResult = this.CreateResult.bind(this);
        this.CreateHistoricalBucketInfo =
            this.CreateHistoricalBucketInfo.bind(this);
        this.RemoveHistoricalBucketInfo =
            this.RemoveHistoricalBucketInfo.bind(this);
    }
    CreateOracle(request) {
        const data = exports.MsgCreateOracle.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.oracle.Msg", "CreateOracle", data);
        return promise.then((data) => exports.MsgCreateOracleResponse.decode(new minimal_1.default.Reader(data)));
    }
    UpdateOracle(request) {
        const data = exports.MsgUpdateOracle.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.oracle.Msg", "UpdateOracle", data);
        return promise.then((data) => exports.MsgUpdateOracleResponse.decode(new minimal_1.default.Reader(data)));
    }
    RemoveOracle(request) {
        const data = exports.MsgRemoveOracle.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.oracle.Msg", "RemoveOracle", data);
        return promise.then((data) => exports.MsgRemoveOracleResponse.decode(new minimal_1.default.Reader(data)));
    }
    SetOracleSlashEnabled(request) {
        const data = exports.MsgSetOracleSlashEnabled.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.oracle.Msg", "SetOracleSlashEnabled", data);
        return promise.then((data) => exports.MsgSetOracleSlashEnabledResponse.decode(new minimal_1.default.Reader(data)));
    }
    UpdateOracleContract(request) {
        const data = exports.MsgUpdateOracleContract.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.oracle.Msg", "UpdateOracleContract", data);
        return promise.then((data) => exports.MsgUpdateOracleContractResponse.decode(new minimal_1.default.Reader(data)));
    }
    DeployOracleContract(request) {
        const data = exports.MsgDeployOracleContract.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.oracle.Msg", "DeployOracleContract", data);
        return promise.then((data) => exports.MsgDeployOracleContractResponse.decode(new minimal_1.default.Reader(data)));
    }
    UpdateParams(request) {
        const data = exports.MsgUpdateParams.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.oracle.Msg", "UpdateParams", data);
        return promise.then((data) => exports.MsgUpdateParamsResponse.decode(new minimal_1.default.Reader(data)));
    }
    CreateResult(request) {
        const data = exports.MsgCreateResult.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.oracle.Msg", "CreateResult", data);
        return promise.then((data) => exports.MsgCreateResultResponse.decode(new minimal_1.default.Reader(data)));
    }
    CreateHistoricalBucketInfo(request) {
        const data = exports.MsgCreateHistoricalBucketInfo.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.oracle.Msg", "CreateHistoricalBucketInfo", data);
        return promise.then((data) => exports.MsgCreateHistoricalBucketInfoResponse.decode(new minimal_1.default.Reader(data)));
    }
    RemoveHistoricalBucketInfo(request) {
        const data = exports.MsgRemoveHistoricalBucketInfo.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.oracle.Msg", "RemoveHistoricalBucketInfo", data);
        return promise.then((data) => exports.MsgRemoveHistoricalBucketInfoResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
var globalThis = (() => {
    if (typeof globalThis !== "undefined")
        return globalThis;
    if (typeof self !== "undefined")
        return self;
    if (typeof window !== "undefined")
        return window;
    if (typeof global !== "undefined")
        return global;
    throw "Unable to locate global object";
})();
const atob = globalThis.atob ||
    ((b64) => globalThis.Buffer.from(b64, "base64").toString("binary"));
function bytesFromBase64(b64) {
    const bin = atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
        arr[i] = bin.charCodeAt(i);
    }
    return arr;
}
const btoa = globalThis.btoa ||
    ((bin) => globalThis.Buffer.from(bin, "binary").toString("base64"));
function base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr) {
        bin.push(String.fromCharCode(byte));
    }
    return btoa(bin.join(""));
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
